import { render, staticRenderFns } from "./LightDownload.vue?vue&type=template&id=25893f27&"
import script from "../../models/customers/light-download.ts?vue&type=script&lang=ts&"
export * from "../../models/customers/light-download.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports